"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const common_utils_1 = require("@zapier/common-utils");
const PathDropdownItem_1 = __importDefault(require("./PathDropdownItem"));
const PathDropdownItems = ({ pathNodes, flowNodes, onToggleMenu, onSelectPath, shouldShowSiblingTreeLine, generation, hasAunt, onDescendGeneration, currentNode, }) => (react_1.default.createElement(react_1.Fragment, null, lodash_1.default.map(pathNodes, (pathNode, i, allChildren) => {
    const hasYoungerSibling = common_utils_1.exists(allChildren[i + 1]);
    const hasAnAunt = hasAunt || (generation === 1 && hasYoungerSibling);
    return (react_1.default.createElement(PathDropdownItem_1.default, { childPaths: pathNode.childPaths, currentNode: currentNode, flowNodes: flowNodes, generation: generation, hasAunt: hasAnAunt, hasYoungerSibling: hasYoungerSibling, key: pathNode.id, onDescendGeneration: onDescendGeneration, onSelectPath: onSelectPath, onToggleMenu: onToggleMenu, pathNode: pathNode, shouldShowSiblingTreeLine: shouldShowSiblingTreeLine }));
})));
exports.default = PathDropdownItems;
